export const NEW_TU_DROPPABLE_ID = 'new-transport-unit';
export const ADD_ITEM_DROPPABLE_PREFIX = 'add-item:';
export const NEW_SUB_UNIT_DROPPABLE_PREFIX = 'new-sub-unit:';

export const MAX_TRANSPORT_UNIT_DEPTH = 3;

export const addItemDroppableId = (tuId: string): string => `${ADD_ITEM_DROPPABLE_PREFIX}${tuId}`;
export const newSubUnitDroppableId = (tuId: string): string => `${NEW_SUB_UNIT_DROPPABLE_PREFIX}${tuId}`;
